<div class="is-flex is-align-items-center is-justify-content-flex-end">
  <span class="pr-3" *ngIf="isLarge">{{ progressPercentage | percent }}</span>

  <div id="bar" [ngClass]="{ 'bar--long': isLarge }">
    <div #progress id="progress"></div>
  </div>
</div>
